<script>
	let utilities = require('utilities');

	module.exports = {
		props: {
			toggleOnList: {
				type: Function,
				required: true
			},
			myList: {
				type: Array,
				default: []
			},
			article: {
				required: true
			},
			loggedIn: {
				type: Boolean,
				required: true
			},
			buttonStyle: {
				type: Boolean,
				default: false
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		components: {
			'bookmark-icon': require('components/svg/bookmark-icon.vue').default
		},
		computed: {
			inMyList: function () {
				if (!this.myList) {
					return false;
				}
				let val = this.myList.some(l => l.productId === this.article.uuid);
				return val;
			}
		},
		methods: {
			forceLogin: function () {
				utilities.openModal('#teacher-login-modal');
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	.add-to-my-list-button {
		display: inline-block;

		.bookmark-icon path {
			fill: none;
			stroke: $c-white;
		}
		&.saved .bookmark-icon path {
			fill: $c-white;
			stroke: $c-white;
		}
		&.-link {
			.bookmark-icon path {
				fill: none;
				stroke: $c-blue;
			}
			&.saved .bookmark-icon path {
				fill: $c-blue;
				stroke: $c-blue;
			}
		}
		&.-in-progress:after {
			top: 2px;
		}
	}
</style>
<template>
	<button
		v-if="loggedIn && myList && article"
		type="button"
		class="add-to-my-list-button button tooltip-bottom"
		:disabled="disabled"
		v-progress-click.prevent="() => toggleOnList(article)"
		v-tooltip="'Save' + (inMyList ? 'd' : '') + ' to My List'"
		:class="{
			saved: inMyList,
			'-link': !buttonStyle
		}">
		<bookmark-icon></bookmark-icon>
	</button>
	<button
		v-else-if="!loggedIn"
		type="button"
		class="add-to-my-list-button button tooltip-bottom"
		v-tooltip="'Save to My List'"
		@click.prevent="forceLogin"
		:class="{
			'-link': !buttonStyle
		}">
		<bookmark-icon></bookmark-icon>
	</button>
</template>
